// removed by extract-text-webpack-plugin
module.exports = {"vip1":"vip1___1Mk0U","vip":"vip___3Q8DT","gift":"gift___YBq5n","gift1":"gift1___38QP0"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/brands/vip-gift.module.scss
// module id = 865
// module chunks = 0